export function getSessionStorageByKeys<T extends readonly string[]>(keys: T): Record<T[number], string> {
  return keys.reduce(
    (acc, key) => {
      acc[key as T[number]] = sessionStorage.getItem(key) ?? '';
      return acc;
    },
    {} as Record<T[number], string>,
  );
}
